var _defs, _path, _path2, _line, _line2, _line3, _line4, _path3, _path4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _rect, _rect2, _polygon, _polygon2, _polygon3, _line13, _path5, _path6, _path7, _path8, _path9, _path10, _rect3, _rect4, _rect5, _rect6, _line14, _line15, _line16;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScholarshipsFunds(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 99.21 99.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2,.cls-3,.cls-4,.cls-6,.cls-8{fill:none;stroke-miterlimit:10;}.cls-2,.cls-3{stroke:#d2cecf;}.cls-3,.cls-4,.cls-8{stroke-linecap:square;}.cls-4{stroke:#128bca;}.cls-5{fill:#d2cecf;}.cls-6{stroke:#4c4748;}.cls-7{fill:#a1d7f4;}.cls-8{stroke:#a19b9d;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37.42,36a3.76,3.76,0,0,0-6-3,10.28,10.28,0,0,0-19.52-.39"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37.42,36a3.76,3.76,0,0,0-6-3,10.28,10.28,0,0,0-19.52-.39"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 31.45,
    y1: 15.24,
    x2: 29.29,
    y2: 15.24
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 37.13,
    y1: 15.24,
    x2: 34.97,
    y2: 15.24
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 33.21,
    y1: 17,
    x2: 33.21,
    y2: 19.16
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 33.21,
    y1: 11.32,
    x2: 33.21,
    y2: 13.48
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.62,19.11a3.12,3.12,0,0,1,5-2.51,8.51,8.51,0,0,1,16.16-.32"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M45.62,19.11a3.12,3.12,0,0,1,5-2.51,8.51,8.51,0,0,1,16.16-.32"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 89.49,
    y1: 40.17,
    x2: 90.61,
    y2: 40.17
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 85.19,
    y1: 40.17,
    x2: 86.3,
    y2: 40.17
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 87.9,
    y1: 41.77,
    x2: 87.9,
    y2: 42.88
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 87.9,
    y1: 37.47,
    x2: 87.9,
    y2: 38.58
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 13.67,
    y1: 67.72,
    x2: 15.83,
    y2: 67.72
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 7.99,
    y1: 67.72,
    x2: 10.15,
    y2: 67.72
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 11.91,
    y1: 69.48,
    x2: 11.91,
    y2: 71.64
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 11.91,
    y1: 63.8,
    x2: 11.91,
    y2: 65.96
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 24.04,
    y: 53.81,
    width: 53.26,
    height: 3.23
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 24.04,
    y: 47.3,
    width: 53.26,
    height: 35.66
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "50.67 28.36 18.76 47.22 18.76 53.81 82.58 53.81 82.58 47.22 50.67 28.36"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "50.67 28.36 18.76 47.22 18.76 53.81 82.58 53.81 82.58 47.22 50.67 28.36"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "50.67 28.36 18.76 47.22 18.76 53.81 82.58 53.81 82.58 47.22 50.67 28.36"
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 18.76,
    y1: 47.3,
    x2: 82.58,
    y2: 47.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M45.34,83V64.88a5.33,5.33,0,1,1,10.65,0V83Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M45.34,83V64.88a5.33,5.33,0,1,1,10.65,0V83Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M61.32,83V64.88a5.33,5.33,0,0,1,10.65,0V83Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M61.32,83V64.88a5.33,5.33,0,0,1,10.65,0V83Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M29.36,83V64.88a5.33,5.33,0,1,1,10.65,0V83Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M29.36,83V64.88a5.33,5.33,0,1,1,10.65,0V83Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 18.77,
    y: 82.95,
    width: 63.81,
    height: 7.07
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 18.76,
    y: 82.95,
    width: 63.81,
    height: 7.07
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 18.77,
    y: 82.95,
    width: 63.81,
    height: 7.07
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 18.76,
    y: 82.95,
    width: 63.81,
    height: 7.07
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 21.43,
    y1: 86.49,
    x2: 79.91,
    y2: 86.49
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 21.43,
    y1: 50.46,
    x2: 79.91,
    y2: 50.46
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 9.45,
    y1: 90.02,
    x2: 91.22,
    y2: 90.02
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScholarshipsFunds);
export default __webpack_public_path__ + "static/media/scholarships-funds.47f5ad4dba1291089480591667c7fdf7.svg";
export { ForwardRef as ReactComponent };